import React, { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box } from '@altermaind/web/ui';
import { AlertBadge } from '@/_shared/components/AlertBadge';

export const EmptyState: FC = () => {
  const t = useTranslations('trainingSoftSkills.emptyState');

  return (
    <Box>
      <AlertBadge type='warning' iconName='info' label={t('noContents')} />
    </Box>
  );
};
